export const Montserrat_BASE_LIGHT =
    " text-sm md:text-base font-normal font-Poppins text-Heading_Black  text-center";
